import React, { Component } from 'react';
import a from './img/card/あ.png';
import i from './img/card/い.png';
import u from './img/card/う.png';
import e from './img/card/え.png';
import o from './img/card/お.png';
import ka from './img/card/か.png';
import ki from './img/card/き.png';
import ku from './img/card/く.png';
import ke from './img/card/け.png';
import ko from './img/card/こ.png';
import sa from './img/card/さ.png';
import si from './img/card/し.png';
import su from './img/card/す.png';
import se from './img/card/せ.png';
import so from './img/card/そ.png';
import ta from './img/card/た.png';
import ti from './img/card/ち.png';
import tu from './img/card/つ.png';
import te from './img/card/て.png';
import to from './img/card/と.png';
import na from './img/card/な.png';
import ni from './img/card/に.png';
import nu from './img/card/ぬ.png';
import ne from './img/card/ね.png';
import no from './img/card/の.png';
import ha from './img/card/は.png';
import hi from './img/card/ひ.png';
import hu from './img/card/ふ.png';
import he from './img/card/へ.png';
import ho from './img/card/ほ.png';
import ma from './img/card/ま.png';
import mi from './img/card/み.png';
import mu from './img/card/む.png';
import me from './img/card/め.png';
import mo from './img/card/も.png';
import ya from './img/card/や.png';
import yu from './img/card/ゆ.png';
import yo from './img/card/よ.png';
import ra from './img/card/ら.png';
import ri from './img/card/り.png';
import ru from './img/card/る.png';
import re from './img/card/れ.png';
import ro from './img/card/ろ.png';
import wa from './img/card/わ.png';
import close from './img/btn13.png';
import './view.css';

const imgList = {
    a,i,u,e,o,
    ka,ki,ku,ke,ko,
    sa,si,su,se,so,
    ta,ti,tu,te,to,
    na,ni,nu,ne,no,
    ha,hi,hu,he,ho,
    ma,mi,mu,me,mo,
    ya,yu,yo,
    ra,ri,ru,re,ro,
    wa,
}

class ViewAnswer extends Component {
    render() {
        return (
            <div>
                <div id="overlay">
                    <div onClick={this.props.onClickModal} id="overlay"></div>
                </div>
                <div className="answerimage" id="ans">
                    {/* <div onClick={this.props.onClickCard}> */}
                        <img src={imgList[this.props.current]} id={this.props.current}></img>
                    {/* </div> */}
                    <div className="buttons">
                        <div onClick={this.props.onClickClose}>
                            <img src={close} id="close"></img>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ViewAnswer;
